/**
 * Dev :
 * - ERP (monolithe) : https://back-erp.agrosilo-solutions.com/
 * - POS / logiciel caisse : dossier `back/` → http://localhost:4100
 * Prod : voir environment.prod.ts
 */
const MAIN_ALL_BACKEND = 'https://back-erp.agrosilo-solutions.com/';
const BACK_LOGICIEL_CAISSE_API = 'https://back-logiciel-caisse.agrosilo-solutions.com/';
const LOGICIEL_CAISSE_FRONT_URL = 'https://front-logiciel-caisse.agrosilo-solutions.com/';

export const environment = {
  production: false,
  hmr: false,
  currentModule: 'vente',
  /** Hub partagé : login, inscription, sélection modules. */
  baseUrl: 'https://front-vente.agrosilo-solutions.com',
  erpModules: [
    {
      id: 'vente',
      title: 'Vente',
      description: 'Devis, commandes clients, factures, bons de livraison et POS.',
      icon: 'dollar-sign',
      color: '#7367F0',
        baseUrl: 'https://front-vente.agrosilo-solutions.com',
      defaultRoute: '/dashboards'
    },
    {
      id: 'achat',
      title: 'Achat',
      description: 'Commandes fournisseurs, bons de réception et factures achat.',
      icon: 'shopping-cart',
      color: '#00CFE8',
        baseUrl: 'https://front-achat.agrosilo-solutions.com',
      defaultRoute: '/dashboards'
    },
    {
      id: 'remise_promotion',
      title: 'Remise et promotion',
      description: 'Remises, promotions et référentiels partagés (clients, produits).',
      icon: 'tag',
      color: '#9C27B0',
      baseUrl: 'http://localhost:4206',
      defaultRoute: '/dashboards'
    },
    {
      id: 'comptabilite',
      title: 'Comptabilité',
      description: 'Trésorerie, banque, chèques et gestion de stock.',
      icon: 'credit-card',
      color: '#28C76F',
        baseUrl: 'https://front-comptabilite.agrosilo-solutions.com',
      defaultRoute: '/dashboards'
    },
    {
      id: 'parametre',
      title: 'Paramètres',
      description: 'Entreprise, documents, taxes, utilisateurs, caisse et intégrations.',
      icon: 'settings',
      color: '#82868B',
      /** Front dédié Paramètres */
      baseUrl: 'https://front-parametrage.agrosilo-solutions.com',
      defaultRoute: '/main/parametre/entreprise'
    },
    {
      id: 'parametre_data',
      title: 'Paramètres données',
      description: 'Configuration des produits, clients, fournisseurs et référentiels.',
      icon: 'database',
      color: '#FF9F43',
        baseUrl: 'https://front-paramatrage-donne.agrosilo-solutions.com',
      defaultRoute: '/main/parametre/donnees/produits'
    },
    {
      id: 'gestion_stock',
      title: 'Gestion stock',
      description: 'Stocks, transferts entrepôts, clients, fournisseurs, produits et gammes.',
      icon: 'layers',
      color: '#EA5455',
      baseUrl: 'https://front-gestion-stock.agrosilo-solutions.com',
      defaultRoute: '/gestion-stock/actif'
    }
  ],
  /** Monolithe ERP main-all-backend (users, products, stock, paiements…). */
  apiUrl: MAIN_ALL_BACKEND,
  /** Module clients. */
  client_url: MAIN_ALL_BACKEND,
  /** Module documents (devis, factures, BL…). */
  document_url: MAIN_ALL_BACKEND,
  /** Module fournisseurs. */
  fournisseur_url: MAIN_ALL_BACKEND,
  /** Settings (/api/settings/*). */
  parameters_url: MAIN_ALL_BACKEND,
  /** Paramétrage données (/api/parametrage/*). */
  parametrage_url: MAIN_ALL_BACKEND,
  /** Produits. */
  product_url: MAIN_ALL_BACKEND,
  stock_url: MAIN_ALL_BACKEND,
  notifications_url: MAIN_ALL_BACKEND,
  paiement_url: MAIN_ALL_BACKEND,
  tresorerie_url: MAIN_ALL_BACKEND,
  file_url: 'assets/images/',
  /** Préfixe des images sous `assets/images/logo/` (ex. discount-2.png, barcode.png). */
  image_url: 'assets/images/logo/',
  /** Base fichiers uploadés (logo, cachet) — backend-erp :4000 */
  url_images: 'https://back-erp.agrosilo-solutions.com',

  // ——— POS / logiciel caisse (`back/` :4100) ———
  /**
   * Base API back caisse pour le POS (`/tiers/ticketCaisse/*`, paramètres caisse, auth admin).
   * Services : LogicielCaisseTicketService, Auth, Entrepots, Vendeurs, etc.
   */
  api_logiciel_caisse: BACK_LOGICIEL_CAISSE_API,
  /**
   * POST /api/stock-transferts + GET /api/entrepots/entrepot/all (même back).
   */
  transfertsEntrepotsErpBaseUrl: BACK_LOGICIEL_CAISSE_API,
  /** Application front logiciel caisse (lien externe POS). */
  logiciel_caisse_front_url: LOGICIEL_CAISSE_FRONT_URL,
  /** Code entreprise / station utilisé en dur pour le moment (001 = Kastelo). */
  static_code_entreprise: '001',
};
